<div class="row">
  <div class="col-12">
    <h3 aria-controls="propertyTransferred">
      {{ propertyTransferredOptions.title }}
    </h3>
  </div>
</div>
<div class="row">
  <div class="col-12">
    @if (propertyTransferredOptions.propertyType === propertyTypeEnum.nonDepreciableProperty ||
      (propertyTransferredOptions.propertyType === propertyTypeEnum.depreciableProperty && propertyTransferredResults.agreedAmount > propertyTransferredResults.adjustedCostBaseForDepreciableProperty) ||
      propertyTransferredOptions.propertyType === propertyTypeEnum.capitalPropertyThatIsRealPropertyOwnedByNonResident ||
      (propertyTransferredOptions.propertyType === propertyTypeEnum.mineralAsset && propertyTransferredOptions.isBusinessIncome === false) ||
      (propertyTransferredOptions.propertyType === propertyTypeEnum.debtObligations && propertyTransferredOptions.isBusinessIncome === false) ||
      (propertyTransferredOptions.propertyType === propertyTypeEnum.specificDebtObligations && propertyTransferredOptions.isBusinessIncome === false) ||
      (propertyTransferredOptions.propertyType === propertyTypeEnum.agriInvestment && propertyTransferredOptions.isBusinessIncome === false)) {
      <app-rollover-capital-gain-result
        [options]="options"
        [propertyTransferredResults]="propertyTransferredResults"
        [results]="results"
        [selectedBadge]="selectedBadge">
      </app-rollover-capital-gain-result>
    }

    @if (propertyTransferredOptions.propertyType === propertyTypeEnum.depreciableProperty) {
      <app-rollover-recaptured-depreciation-result
        [options]="options"
        [propertyTransferredOptions]="propertyTransferredOptions"
        [propertyTransferredResults]="propertyTransferredResults"
        [results]="results"
        [selectedBadge]="selectedBadge">
      </app-rollover-recaptured-depreciation-result>
    }

    @if (propertyTransferredOptions.propertyType === propertyTypeEnum.inventoryProperty ||
      (propertyTransferredOptions.propertyType === propertyTypeEnum.mineralAsset && propertyTransferredOptions.isBusinessIncome === true)||
      (propertyTransferredOptions.propertyType === propertyTypeEnum.debtObligations && propertyTransferredOptions.isBusinessIncome === true) ||
      (propertyTransferredOptions.propertyType === propertyTypeEnum.specificDebtObligations && propertyTransferredOptions.isBusinessIncome === true) ||
      (propertyTransferredOptions.propertyType === propertyTypeEnum.agriInvestment && propertyTransferredOptions.isBusinessIncome === true)) {
      <app-rollover-inventory-result
        [options]="options"
        [propertyTransferredOptions]="propertyTransferredOptions"
        [propertyTransferredResults]="propertyTransferredResults"
        [results]="results"
        [selectedBadge]="selectedBadge">
      </app-rollover-inventory-result>
    }

    @if (propertyTransferredOptions.isInternalRollOver === true) {
      <app-rollover-deemed-dividend-84-3-result
        [options]="options"
        [propertyTransferredOptions]="propertyTransferredOptions"
        [propertyTransferredResults]="propertyTransferredResults"
        [results]="results"
        [selectedBadge]="selectedBadge">
      </app-rollover-deemed-dividend-84-3-result>
    }

    @if (propertyTransferredResults.section84_1.isApplicable === true) {
      <app-rollover-deemed-dividend-84-1-result
        [options]="options"
        [propertyTransferredOptions]="propertyTransferredOptions"
        [propertyTransferredResults]="propertyTransferredResults"
        [results]="results"
        [selectedBadge]="selectedBadge">
      </app-rollover-deemed-dividend-84-1-result>
    }
  </div>
</div>
